import { getSecondsElapsed } from './getSecondsElapsed';
import { toOneDecimalPlace } from './toOneDecimalPlace';
import { ForgetfulArray } from '@/classes';
import { Size } from '@/constants';

const { ONE_MEGABIT } = Size;

export const calculateUploadSpeedInMbps = (
  sizeUploadedInMB: number,
  startTime: number,
  endTime: number,
) => {
  const secondsElapsed = getSecondsElapsed(startTime, endTime);

  if (secondsElapsed <= 0) {
    return 0;
  }

  const sizeUploadedInMb = sizeUploadedInMB * 8;
  const uploadSpeedInMbps = sizeUploadedInMb / ONE_MEGABIT / secondsElapsed;
  return toOneDecimalPlace(uploadSpeedInMbps);
};

export const calculateUploadProgress = (sizeUploaded: number, totalSize: number) => {
  if (totalSize <= 0) {
    return 0;
  }

  const progress = (sizeUploaded / totalSize) * 100;
  return toOneDecimalPlace(progress);
};

type ChunkUploadSpeedDetails = {
  packetSize: number;
  startTime: number;
  endTime: number;
};
export const getRecentUploadSpeed = (
  recentUploadSpeedDetails: ForgetfulArray<ChunkUploadSpeedDetails>,
) => {
  const recentDetails = recentUploadSpeedDetails.items;
  if (recentDetails.length === 0) {
    return 0;
  }

  const totalRecentSize = recentDetails.reduce(
    (sizeAccumulator, currentUploadDetails) => sizeAccumulator + currentUploadDetails.packetSize,
    0,
  );
  const [{ startTime }] = recentDetails;
  const { endTime } = recentDetails[recentDetails.length - 1];

  return calculateUploadSpeedInMbps(totalRecentSize, startTime, endTime);
};
